import { rootApi } from "../../api/rootApi";

export const notificationTemplateApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        addNotificationTemplate: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/notification-v2/add`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        getAllNotificationTemplates: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/notification-v2`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        updateNotificationTemplate: builder.mutation({
            query: (params) => {
                return {
                    method: "PUT",
                    url: `/tenant/notification-v2/${params.id}`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
        updateStatusOfNotificationTemplate: builder.mutation({
            query: (params) => {
                return {
                    method: "PUT",
                    url: `/tenant/notification-v2/status/${params.id}`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: {
                        status: params.status,
                    },
                };
            },
        }),
        sendNotification: builder.mutation({
            query: (params) => {
                return {
                    method: "POST",
                    url: `/tenant/push-notification/v3-send`,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + params.token,
                        slug: params.tenant_id,
                    },
                    body: params.body,
                };
            },
        }),
    }),
});

export const {
    useAddNotificationTemplateMutation,
    useGetAllNotificationTemplatesMutation,
    useUpdateNotificationTemplateMutation,
    useUpdateStatusOfNotificationTemplateMutation,
    useSendNotificationMutation,
} = notificationTemplateApi;
